'use strict';

import 'document-register-element';



export class FlashView extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {

  }
  connectedCallback() {
    this.style.setProperty('--delay', `${Math.random() * 10}s`)
  }
}


window.customElements.define('flash-view', FlashView);